import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MbiemriLloji } from '@core/enums/mbiemri.enums';
import { MbiemriAsnjanesForCreationDTO } from '@core/interfaces/dto/mbiemri-asnjanes-for-creation-dto.interface';
import { EditorService } from '../editor.service';

@Injectable({
  providedIn: 'root'
})
export class MbiemriAsnjanesService {

  constructor() { }

  getCreationDTO(mbiemriBaza: any) {
    const creationDTO: MbiemriAsnjanesForCreationDTO[] = [];

    let formArray: any[] = mbiemriBaza.mbiemriAsnjanesEmerMbiemer.concat(mbiemriBaza.mbiemriAsnjanesMbiemerEmer);

    for (var i = 0; i < formArray.length; i++) {
      const e = formArray[i];

      if (mbiemriBaza.llojiId == MbiemriLloji.Inyjshem && e.formaFjalesId != null)
        continue;

      creationDTO.push({
        trajtaId: e.trajtaId,
        numriId: e.numriId,
        rasaId: e.rasaId,
        renditjaId: e.renditjaId,
        formaFjalesId: e.formaFjalesId,
        pershkrimi: e.pershkrimi,
        radhitja: e.radhitja
      });
    }

    return creationDTO;
  }
}
